var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcase26(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 23.25H22.5C22.914 23.25 23.25 22.914 23.25 22.5V18.75H0.75V22.5C0.75 22.914 1.086 23.25 1.5 23.25Z",
    fill: "#B5B7C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 4.5H16.5V1.5C16.5 1.086 16.164 0.75 15.75 0.75H8.25C7.836 0.75 7.5 1.086 7.5 1.5V4.5H0.75C0.336 4.5 0 4.836 0 5.25V16.5C0 16.914 0.336 17.25 0.75 17.25H23.25C23.664 17.25 24 16.914 24 16.5V5.25C24 4.836 23.664 4.5 23.25 4.5ZM9 2.25H15V4.5H9V2.25ZM16.5 13.5H7.5V9H16.5V13.5Z",
    fill: "#B5B7C6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase26);
export default __webpack_public_path__ + "static/media/briefcase-26.9e69f63e5eabcb406e069a36da7a9ecf.svg";
export { ForwardRef as ReactComponent };